import { action } from '@reatom/framework'

import { Array, pipe, Result } from '@blade/std-lib'
import { ApiError, apiRequest } from '@root/shared/api'
import { tradeApiClientAtom } from '@root/shared/api/trade-api-client-atom'

import { Referee } from '../model'

export const fetchUserReferralsRequestAction = action(async (ctx) => {
  const { tradeApiClient } = ctx.get(tradeApiClientAtom)

  const result = await ctx.schedule(() =>
    apiRequest(ctx, tradeApiClient.referral.referralsList, []),
  )

  const mappedResult = pipe(
    result,
    Result.map(Array.map((dto) => Referee.fromDto(dto))),
    Result.mapError(ApiError.fallbackToUnknown),
  )

  return mappedResult
}, 'fetchUserReferralsRequestAction')
